import React from 'react';
import { Button, MessageDialog } from 'Components/Core';
import { IconLock } from 'Lib/Icons';
import { IconBaseProps } from 'react-icons';
import { useSelector } from 'react-redux';
import * as oPath from 'Lib/Object/Path/Immutable';
import deepEquals from 'Lib/Object/deepEquals';

/**
 * Component that returns an icon indicating that the worksheet is locked
 */

type WorksheetLockedStatusIconProps = {
  worksheetPath: string;
  size?: IconBaseProps['size'];
};

const WorksheetLockedStatusIcon: React.FC<WorksheetLockedStatusIconProps> = ({ worksheetPath, size }) => {
  const status = useSelector((s) => oPath.get(s, `${worksheetPath}.status`), deepEquals);

  return status.readonly.locked ? (
    <MessageDialog messageTitle="Worksheet Locked" messageText={status.readonly.lockedMessage} alwaysEnabled>
      <Button subtle noPadding alwaysEnabled>
        <IconLock size={size} />
      </Button>
    </MessageDialog>
  ) : null;
};

export default WorksheetLockedStatusIcon;
export { WorksheetLockedStatusIcon };
